import React, { useState, useEffect } from 'react';
import './Notification.css';

const Notification = ({ message, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setIsVisible(true);
      const timer = setTimeout(() => {
        setIsVisible(false);
        setTimeout(onClose, 300); // Espera a que termine la animación
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [message, onClose]);

  if (!message) return null;

  return (
    <div className={`notification ${isVisible ? 'notification-show' : 'notification-hide'}`}>
      <div className="notification-content">
        <div className="notification-icon">🎉</div>
        <div className="notification-message">{message}</div>
        <button className="notification-close" onClick={() => setIsVisible(false)}>
          ×
        </button>
      </div>
    </div>
  );
};

export default Notification;
